function myFunction(para) {

  if(para==1) {
    
    /*if($("#open_close").css('display') == 'none') {
     $('.page-container').addClass('wash');
    } else {
  	 $('.page-container').removeClass('wash');  
    }*/
    
    $("#open_close").slideToggle(500);
    $(".menu_div_two").show();
    $(".toplmenu1").hide();
    $('.mobilemenu').hide();  
    $('.refer_popup_sec1').slideToggle();
    

    if(!$(".search_icon").hasClass("active"))
      setTimeout(function(){ $(".form_search_result input[type='search']").focus(); }, 500);

    $(".search_icon").toggleClass("active");
    
    // $(".form_search_result input[type='search']").focus();
    
  } else {
    var element = document.getElementById("PageContainer");
    // element.classList.toggle("wash");
    $("#open_close").slideToggle(500);
    $('.refer_popup_sec1').slideToggle();
    //$('#search').focus();
    $(".search_icon").toggleClass("active");
  }
}

function searchHover(){
  // $('.drawer-cover').hide();                                     
  hideCartDrawer(); // $('.drawer').hide('slide', {direction: 'right'}, 400);
  $('.cart-drawer__content').show(); 
}

function myFunctionmob() {
  //$('.page-container').toggleClass('wash');  
  
  /*if($("#open_close").css('display') == 'none') {
    $('.page-container').addClass('wash');  
  } else {
  	$('.page-container').removeClass('wash');  
  }*/

  var search_closed = $("#open_close").css('display') == 'block' ? false : true;


  $("#open_close").slideToggle(500);
  hideCartDrawer(); // $('.drawer').hide('slide', {direction: 'right'}, 400);
  // $('.drawer-cover').hide();
  
  if($(".mobilemenu").css('display') == 'block') {
    $('.mobilemenu').slideToggle();
    $('.icon--nav-anim').toggleClass('open');
  }else if(search_closed){
    //Focus on search if box has opened;
    if($('.mobile_search_enabled')[0]){
        $(".form_search_result input[type='search']").focus();
    }else{
        setTimeout(function(){ $(".form_search_result input[type='search']").focus(); }, 500);
    }
  }

  /*
  setTimeout(function() {
    if(($('.drawer').css('display') == 'none') && ($('#open_close').css('display') == 'none')) {
      $("#PageContainer").removeClass("wash");
    }
  },200);
  */
}

/* 
  Functions to add mobile search functionality to the site as well 
  as handle bugs from fast simons mobile search being injected.
*/
function init_mobile_search(){
  /* 
    Check to see if standard mobile search is enabled otherwise 
    fast simon will be used instead.
  */
  if($('.mobile_search_enabled')[0]){
    /* 
      Since fast simon doesn't have an event handler for when it 
      overrides mobile search we look for an onclick attribute 
      that fast simon adds to the search_icon. Because of this
      we don't want to use an onclick attribute for our standard 
      function at mobile smaller breakpoints so we add an onclick 
      event listener to mobile search icon insead of using an 
      attribute. We add this on window load because it prevents
      most cases of accessing the standard search before fast simon
      has a chance to load.
    */
    $(window).load(function () {
      $('.main_class_mobile .search_icon').on('click', function(){
        if(!$(this).attr("onclick")){
          myFunctionmob();
        }
      });
    });

    /* 
        Mobile searches may be replaced by Fast Simon
        To avoid issues we need to check for focus or 
        keyup when entering searches and manually prevent
        non mobile search from appearing.
    */
    $('.search_form input').on('focus keyup', function(event){
      var search_icon = $('.main_class_mobile .search_icon');

      /*
          By default onclick is not an attribute on the mobile search 
          icon. If there is an onclick attribute present then we know 
          fast simon has replaced the standard search with their mobile 
          search.
      */
      if(search_icon.attr("onclick")){

        /*
          If fast simon is using their mobile search we makse sure to 
          hide the non mobile search. 
        */
        $("#open_close").css('display', 'none');

        /*
          If this was caught using the keyup event then we know that 
          mobile search loaded after the user started typing in the 
          non mobile search. We open the correct search by simulating
          a new click on the search icon, and make sure to regular
          search doesn't appear open by removing its active class.
        */
        if(event.type == "keyup"){
          search_icon.click();
          search_icon.removeClass("active");
        }
      }
    });
  }
}
init_mobile_search();

function showCartDrawer(){
  // $('.drawer').show('slide', {direction: 'right'}, 400);
  $('.drawer').show("slow");
}
function hideCartDrawer(){
  // $('.drawer').hide('slide', {direction: 'right'}, 400);
  $('.drawer').hide("slow");
  $('.drawer-cover').hide();
}
function toggleCartDrawer(){
  // $('.drawer').toggle('slide', {direction: 'right'}, 400);
  $('.drawer').toggle("slow");
}

function showcart(para) {
  Shopify.onCartUpdate = function(cart) {
    Shopify.updateCartInfo(cart, '.cart-drawer');
  };
  if(para==1) {
    // Fix slide error
    // $('.drawer').show('slide', {direction: 'right'}, 400);
    showCartDrawer()
    
    /*if($('.page-container').not('wash')) {         
      $('.page-container').addClass('wash');  
    }*/
    
    $('.drawer-cover').show();                                    
    $('.header-top-user-menu').css({'right':'-310px'});

    if($('#CartCount').text()!='0') {
      $('.cart-drawer__empty-text').addClass('hide');
      $('.cart-drawer__footer').removeClass('hide');
    } else {
      $('.cart-drawer__footer').addClass('hide');
      $('.cart-drawer__empty-text').removeClass('hide');
    }
  } else {
    /*if($("#open_close").css('display') == 'block') {} else {
      $('.page-container').removeClass('wash');  
    }*/
    // $('.drawer-cover').hide();
    // Fix slide error
    // $('.drawer').hide('slide', {direction: 'right'}, 400);
    hideCartDrawer()
    $('.drawer').css({'display': "none"});

    $('.cart-drawer__content').show();
  }
}

function showcartmob() {
  toggleCartDrawer();// $('.drawer').toggle('slide', {direction: 'right'}, 400);
  
  /*if($(".drawer-cover").css('display') == 'none') {
    $('.page-container').addClass('wash');  
  } else {
    if($("#open_close").css('display') == 'block') {} else {
  	$('.page-container').removeClass('wash');  
    }
  }*/
  
  if($(".mobilemenu").css('display') == 'block') {
    $('.mobilemenu').slideToggle();
    $('.icon--nav-anim').toggleClass('open');
  }
  
  /*
  if($('.page-container').not('wash')) {         
    $('.page-container').addClass('wash');  
  } else {
  	$('.page-container').removeClass('wash');  
  }
  */
  
  $('.drawer-cover').toggle();    
  
  /*
  setTimeout(function() {
    if(($('.drawer').css('display') == 'none') && ($('#open_close').css('display') == 'none')) {
      $("#PageContainer").removeClass("wash");
    }
  },200);
  */
}

$('.drawer-cover').hover(function() {
  /*if($("#open_close").css('display') == 'none') {
    $('.page-container').removeClass('wash');  
  }*/
  
  // $('.drawer-cover').hide();
  // Fix slide error
  // $('.drawer').hide('slide', {direction: 'right'}, 400);
  hideCartDrawer()
  $('.cart-drawer__content').show();	
});

$('.drawer-cover').click(function() {
  // $('.page-container').removeClass('wash');  
  // $('.drawer-cover').hide();                                     
  hideCartDrawer(); // $('.drawer').hide('slide', {direction: 'right'}, 400);
  $('.cart-drawer__content').show();
});

function showacc() {
  hideCartDrawer();  // $('.drawer').hide('slide', {direction: 'right'}, 400);
  /*if($("#open_close").css('display') == 'block') {} else {
    $('.page-container').removeClass('wash');  
  }*/
  // $('.drawer-cover').hide();   
}

$(".user_icon").bind("mouseenter focusin", function(){
  $(this).find(".header_account").attr("aria-expanded", "true");
});

$(".user_icon").bind("mouseleave focusout", function(){
  $(this).find(".header_account").attr("aria-expanded", "false");
});

function my_menu(para) {
  $(".toplmenu1").toggle();
  $('.mobilemenu').slideToggle();
  $('.icon--nav-anim').toggleClass('open');  
  
  /*
  if(para==1) {
    $(".menu_div_two").hide();
    $(".toplmenu1").show();
    $('.mobilemenu').show();
  } else {
    $(".menu_div_two").show();
    $(".toplmenu1").hide();
    $('.mobilemenu').hide();   
  }
  */
}

function showd(element, para) {
  //$('.sndnn').hide();
  if($('.snd'+para).css('display') == 'none') {
    $('.snd'+para).show();
    $(element).children('.minus').show();
    $(element).children('.plus').hide();
  } else {
    $('.snd'+para).hide();
    $(element).children('.minus').hide();
    $(element).children('.plus').show();
  }
}

$(".refer_popup_sec1").click(function(){
  $("#open_close").slideToggle(500);
  $('#search').focus();
  $('.refer_popup_sec1').hide();
  // $("#PageContainer").toggleClass("wash");
  $(".search_icon").toggleClass("active");

  $('.cardrawr').remove($('.cardrawr div'));  
  $('.drawer').hide();
});

$("#users").mouseover(function(){$("#user_ac").show(2000);});

$("#users").mouseleave(function(){$("#user_ac").hide(2000);});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

function popupFinder() {
    var t = $(this).data('popup-find');
    $('[data-popup="'+t+'"]').show();
}

// Removed price masking
/*
// remove after holiday - or modify and reuse
// @todo check if product has map price before overriding
const currentPromoItemTags = ['Black Friday', 'Cyber Monday', 'department_APPAREL', 'holiday_sale'];
const pricemodifier = 0.75;

function promoPriceChangerPDP() {
	// this will 'mask' the price on display to show a discount
	// that is actually automatically being applied in cart
	// @todo code around MAP rules
	// @todo code around whether discount is off original or current price
	const $pricediv = $('.product__price');
	let $meta = $pricediv.find('meta[data-current-price]');
	let currentprice = $meta.data('current-price');
	let originalprice = $meta.data('original-price');
	let promoprice = Math.round(currentprice*pricemodifier) / 100;
	const data = JSON.parse(document.getElementById('ProductJson-product-template').innerHTML);
	if( data.tags.includes(currentPromoItemTags[0]) || data.tags.includes(currentPromoItemTags[1]) ) {
		if(data.tags.includes(currentPromoItemTags[2])){
			$pricediv.find('.price__regular').html('<dd><s class="price-item price-item--regular" data-regular-price>$'+(Math.round(originalprice) / 100).toFixed(2)+'</s></dd>');
			$pricediv.find('.price__sale').remove();
			$pricediv.find('dl.price').removeAttr('data-price').addClass('price--on-sale').append('<div class="price__sale"><dd><span class="price-item price-item--sale">$'+(promoprice).toFixed(2)+'</span></dd></div>');
		}
	}
}
*/

const breakpoint = 760;

$(document).ready( function() {

	//body class for desktop
	if($(window).width() > breakpoint) {
		$('body').addClass('view--desktop');
	}

	$(window).scroll(function() {        
		if($(window).scrollTop() < 60) {
			$(".banner--clone").removeClass('banner--stick');
			$("body").removeClass('stickit');
		} else {             
			$(".banner--clone").addClass('banner--stick');
			$("body").addClass('stickit');
		}
	});

  	// popups
    $('[data-popup-find]').on('click', popupFinder);
    $('.popup').on('click', function(e) {
        if (e.target !== this) {return;}
        $(this).hide();
    });
    // universal popup hider for keypress
    $(document).keyup(function(e) {
    	if(e.key == "Escape") {
    		if($('.popup')[0]) {
        		$('.popup').hide();
    		}
    	}
    });

    $('.product-blog article').on('click', function() {
        $(this).toggleClass('open').find('.post').slideToggle();
    });

    // Removed price masking
    // if($('body').hasClass('template-product')) {promoPriceChangerPDP();}
});

/**
 * On: focus blur => Floating label
 * Based on http://jsfiddle.net/RyanWalters/z9ymd852/
*/
// Also on input/change: a value pasted, picked or autofilled without a focus/blur left the
// label sitting on top of the text (a script .val() still needs .trigger('change')). Keep it raised while the field has focus.
$('.input-box input, .input-box textarea , .input-box select , .control input').on('focus blur input change', function (e) {
  $(this).parents('.input-box , .control').toggleClass('in-use', (e.type === 'focus' || (e.type !== 'blur' && this === document.activeElement) || this.value.length > 0));

}).trigger('blur');

var yourNavigation = $(".form_search_result_me");
stickyDiv = "head_sticky_is-sticky";
yourHeader = $('.main_class').height();

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeader ) {
    yourNavigation.addClass(stickyDiv);
  } else {
    yourNavigation.removeClass(stickyDiv);
  }
});

var yourNavigations = $(".head_sticky");
stickyDivs = "head_sticky_is-sticky";
yourHeaders = $('.head_sticky').height();

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeaders ) {
    yourNavigations.addClass(stickyDivs);
    $('.header_account').addClass('header_account_active');
  } else {
    yourNavigations.removeClass(stickyDivs);
    $('.header_account').removeClass('header_account_active');
  }
});

$(".icon--circle").click(function(){
  if($(".asset-icons").hasClass('open')) {
    $(".asset-icons").removeClass('open').fadeIn(1000);
  } else {
    $(".asset-icons").addClass('open').fadeIn(1000);
  }

  if($(".icon-more").hasClass('open')) {
    $(".icon-more").removeClass('open')
  } else {
    $(".icon-more").addClass('open')
  }
});

function afterpay(para) {
  if(para==1) {
    $('.afterpay_main_popup').fadeIn(500);
  } else {
    $(".afterpay_main_popup").fadeOut(600);
  }
}

var yourNavigation_jordan = $(".jordan_sticky");
stickyDiv_jordan = "jordan_sticky_is_sticky";

yourHeader_jordan = $('.head_sticky ').height();

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeader_jordan ) {
    yourNavigation_jordan.addClass(stickyDiv_jordan);
  } else {
    yourNavigation_jordan.removeClass(stickyDiv_jordan);
  }
});



/* Begin Modal UI Logic */
(function ($) {

  // Initialize global object to store modal operations
  window.HeaderUIModals = window.HeaderUIModals || {};

  let header_ui_modal_containers = $('.header_ui_modal_container');

  header_ui_modal_containers.each(function() {
    let header_ui_modal_container = $(this);
    let modal_id = header_ui_modal_container.data("modal-id");
    let header_ui_modal = header_ui_modal_container.find('.header_ui_modal');
    let click_off_ui = header_ui_modal_container.find('.header_ui_modal-click-off');
    let modal_open_button = $(`[data-modal-open="${modal_id}"]`);
    let close_ui = header_ui_modal.find('.header_ui_modal-close');
    let modal_slider = header_ui_modal.find('.header_ui_modal-slider');
    let selected_button;
    let history_state_pushed = false;

    function setModalOpenButtonExpanded(expanded) {
      modal_open_button.attr('aria-expanded', expanded ? 'true' : 'false');
    }

    function getFocusableElements($root) {
      return $root.find(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ).filter(function () {
        const $el = $(this);
        // Off-screen promo slides are aria-hidden/inert (DTLRSlider) but still :visible inside the
        // overflow-hidden bar, so keep their controls out of the trap's first/last calculation
        if ($el.closest('[aria-hidden="true"], [inert]').length || $el.attr('tabindex') === '-1') return false;
        return $el.is(':visible') && $el.css('visibility') !== 'hidden';
      });
    }

    function focusInitialModalElement() {
      const $close = close_ui.first();
      if (modal_id === 'page-filter') {
        const $firstAccordion = header_ui_modal.find('.dtlr_accordion-trigger').first();
        const $target = $close.length ? $close : $firstAccordion;
        if ($target.length) {
          $target.trigger('focus');
        }
        return;
      }
      if ($close.length) {
        $close.trigger('focus');
      }
    }

    function handleModalKeydown(event) {
      if (!header_ui_modal.hasClass('active')) return;

      if (event.key === 'Escape') {
        // Dialogs opened from inside a tray sit above it and close themselves on Escape, but the
        // same keydown reaches this document handler: Zip's modal (cart tray Zip logo) and the
        // swal2 Buy Now, Pay Later dialog (store picker / filter drawer promo bar). Leave the
        // tray open so one Escape closes only the topmost layer. The swal2 check is by event
        // origin, so a tray opened on top of a swal2 dialog (cart over quick view) still closes.
        if (window.DTLRZip && window.DTLRZip.isModalOpen()) return;
        if ($(event.target).closest('.swal2-container').length) return;

        event.preventDefault();
        close_tray();
        return;
      }

      if (event.key !== 'Tab') return;

      const $focusable = getFocusableElements(header_ui_modal);
      if (!$focusable.length) return;

      const first = $focusable[0];
      const last = $focusable[$focusable.length - 1];

      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    
    // The promo bar is a DTLRSlider (dtlr-theme-js.liquid), built once at page load; it only rotates
    // while the tray is open. Percent-based layout, so nothing is rebuilt or re-measured per open.
    function get_modal_slider() {
      if (!modal_slider.length || !window.DTLRSlider) return null;
      return window.DTLRSlider.get(modal_slider[0]);
    }

    function start_modal_slider() {
      const slider = get_modal_slider();
      if (slider) slider.start();
    }

    function stop_modal_slider() {
      const slider = get_modal_slider();
      if (slider) slider.stop();
    }

    function activateModalTray() {
      requestAnimationFrame(function () {
        if (header_ui_modal[0]) {
          void header_ui_modal[0].offsetHeight;
        }
        requestAnimationFrame(function () {
          header_ui_modal.addClass('active');
          start_modal_slider();
        });
      });
    }

    // SweetAlert2 stamps aria-hidden="true" on every other <body> child while one of its dialogs is
    // open. When a tray opens on top of one (e.g. the cart after adding from the quick view), lift
    // that from the tray's top-level section so screen readers can reach it; restore it on close.
    function get_body_child(){
      return header_ui_modal_container.parents().filter(function(){
        return this.parentElement === document.body;
      }).first();
    }

    // Only lifts on tray open; a swal2 dialog fired while a tray is already open re-hides it
    // (rare: see the tech-debt log). The whole header section is exposed, which is fine because
    // the tray itself is aria-modal.
    function expose_above_swal(){
      if (!document.body.classList.contains('swal2-shown')) return;
      const $top = get_body_child();
      if ($top.attr('aria-hidden') === 'true') {
        $top.removeAttr('aria-hidden').attr('data-dtlr-swal-exposed', 'true');
      }
      // Hide the swal2 dialog under the tray and drop its aria-modal, so screen readers (VoiceOver
      // in particular) don't treat two modal dialogs as open at once.
      $('.swal2-container').attr({ 'aria-hidden': 'true', 'data-dtlr-swal-covered': 'true' });
      $('.swal2-popup[aria-modal="true"]').removeAttr('aria-modal').attr('data-dtlr-swal-modal', 'true');
    }

    function restore_swal_hidden(){
      $('.swal2-container[data-dtlr-swal-covered]').removeAttr('aria-hidden data-dtlr-swal-covered');
      $('.swal2-popup[data-dtlr-swal-modal]').attr('aria-modal', 'true').removeAttr('data-dtlr-swal-modal');

      const $top = get_body_child();
      if (!$top.attr('data-dtlr-swal-exposed')) return;
      $top.removeAttr('data-dtlr-swal-exposed');
      if (document.body.classList.contains('swal2-shown')) {
        $top.attr('aria-hidden', 'true');
      }
    }

    // Focus target on close: the trigger/return element if it's still on the page and visible,
    // otherwise this tray's own open button (e.g. the header cart icon).
    function get_return_focus(){
      const el = selected_button && selected_button[0];
      if (el && el.isConnected && selected_button.is(':visible') && !el.disabled) {
        return selected_button;
      }
      return modal_open_button.filter(':visible').first();
    }

    // Opened from code rather than a trigger click (e.g. the cart after add to cart): there's no
    // trigger button to return focus to on close, so use options.returnFocus if the caller knows
    // it (the add-to-cart button is disabled mid-request, which drops focus), else whatever has focus.
    function open_tray_programmatically(options){
      const target = (options && options.returnFocus) || document.activeElement;
      const valid = target && target !== document.body && !header_ui_modal_container[0].contains(target);
      selected_button = valid ? $(target) : null;
      open_tray();
    }

    function open_tray(){
      modal_open_button.prop('disabled', true);
      header_ui_modal.removeClass('hidden');
      click_off_ui.removeClass('hide-click-off');
      expose_above_swal();

      setModalOpenButtonExpanded(true);

      // Store current scroll position to prevent page jump
      const scrollY = window.scrollY;
      const $body = $('body');
      $body.css({
        'position': 'fixed',
        'top': `-${scrollY}px`,
        'width': '100%'
      });
      $body.addClass('modal-open');
      $body.data('scroll-position', scrollY);

      // Push history state for back button handling
      if (!history_state_pushed) {
        history.pushState({ modalOpen: modal_id }, '');
        history_state_pushed = true;
      }

      activateModalTray();

      setTimeout(function(){
        if (modal_id === 'page-filter' && window.DTLRPageFilters
          && typeof window.DTLRPageFilters.prepareFilterModalOpen === 'function') {
          window.DTLRPageFilters.prepareFilterModalOpen();
        }

        focusInitialModalElement();
      }, 50);
      setTimeout(()=>{
        modal_open_button.prop('disabled', false);
      },500);
    }

    function close_tray(skip_history, options){
      options = options || {};
      modal_open_button.prop('disabled', true);
      header_ui_modal.removeClass("active");
      click_off_ui.addClass('hide-click-off');
      stop_modal_slider();

      setModalOpenButtonExpanded(false);
      
      // Restore scroll position smoothly
      const $body = $('body');
      const scrollY = $body.data('scroll-position') || 0;
      $body.removeClass('modal-open');
      
      // Use requestAnimationFrame to ensure scroll restoration happens in sync with style removal
      requestAnimationFrame(() => {
        $body.css({
          'position': '',
          'top': '',
          'width': ''
        });
        window.scrollTo(0, scrollY);
      });
      
      // Go back in history if we pushed a state and not called from popstate.
      // page-filter / location: avoid history.back() — Fast Simon may update the URL when
      // filters or store location apply after the modal opens, and going back can undo those params.
      if (history_state_pushed && !skip_history) {
        if (modal_id === 'page-filter' || modal_id === 'location') {
          if (history.state && history.state.modalOpen === modal_id) {
            history.replaceState(null, '', window.location.href);
          }
        } else {
          history.back();
        }
      }
      history_state_pushed = false;

      if (modal_id === 'page-filter' && window.DTLRPageFilters
        && typeof window.DTLRPageFilters.closeFilterModalSession === 'function') {
        window.DTLRPageFilters.closeFilterModalSession();
      }

      if (modal_id === 'page-filter' && window.DTLRPageFilters
        && typeof window.DTLRPageFilters.reapplyActiveNarrows === 'function'
        && !options.skipReapply) {
        window.DTLRPageFilters.reapplyActiveNarrows();
      }
      
      setTimeout(()=>{
        modal_open_button.prop('disabled', false);
        header_ui_modal.addClass('hidden');
        restore_swal_hidden();
        get_return_focus().trigger("focus");
      },500);
    }
    
    // Handle back button press
    window.addEventListener('popstate', function(event) {
      if (history_state_pushed && header_ui_modal.hasClass('active')) {
        let narrowsSnapshot = null;

        if (modal_id === 'page-filter' && window.DTLRPageFilters
          && typeof window.DTLRPageFilters.snapshotActiveNarrows === 'function') {
          narrowsSnapshot = window.DTLRPageFilters.snapshotActiveNarrows();
          event.stopImmediatePropagation();
        }

        close_tray(true, { skipReapply: !!narrowsSnapshot });

        if (narrowsSnapshot && window.DTLRPageFilters
          && typeof window.DTLRPageFilters.restoreActiveNarrows === 'function') {
          window.requestAnimationFrame(function () {
            window.DTLRPageFilters.restoreActiveNarrows(narrowsSnapshot);
            history.replaceState(null, '', window.location.href);
          });
        }
      }
    }, true);
    function init_header_ui_modal_events(){
      modal_open_button.on('click', function(e) {
        e.preventDefault();
        selected_button = $(this);
        open_tray();
      });

      close_ui.on('click', function(e) {
        e.preventDefault();
        header_ui_modal.removeClass("active");
        close_tray();
      });

      click_off_ui.on('click', function(e) {
        e.preventDefault();
        header_ui_modal.removeClass("active");
        close_tray();
      });

      $(document).on('keydown.dtlrHeaderModal-' + modal_id, handleModalKeydown);
    }

    function init_header_ui_modal(){
      init_header_ui_modal_events();
    }
    init_header_ui_modal();

    // Store modal operations in global object for external access
    window.HeaderUIModals[modal_id] = {
      open: open_tray_programmatically,
      close: close_tray,
      modal: header_ui_modal,
      container: header_ui_modal_container
    };
  });
})(jQuery);

// Mobile Nav Operations
(function ($) {

  let mobile_nav_modal = $('.header_ui_modal_id-mobile-nav');
  let mobile_nav_modal_close = mobile_nav_modal.find('.header_ui_modal-close');
  let mobile_nav_modal_click_off = mobile_nav_modal.find('.header_ui_modal-click-off');
  let mobile_nav = $('.main_nav-mobile');
  let mobile_nav_elements = mobile_nav.find('.main_nav-element');
  let mobile_nav_child_elements = mobile_nav.find('.main_nav-childlist-item');

  function getGrandchildList($childItem) {
    return $childItem.children('.main_nav-grandchildlist');
  }

  function setGrandchildListExpanded($childItem, expand) {
    const $list = getGrandchildList($childItem);
    // The image column's caption list is always open (site-nav-children-mobile.liquid puts the class on
    // a wrapper div around the li, so hasClass() on the li never matched and the caption got collapsed)
    if (!$list.length || $childItem.closest('.main_nav-image-childlist-element').length) return;

    if (expand) {
      $childItem.addClass('expanded');
      $list.css('max-height', $list[0].scrollHeight + 'px');
    } else {
      $childItem.removeClass('expanded');
      $list.css('max-height', '0');
    }
  }

  function resetGrandchildLists() {
    mobile_nav_child_elements.each(function () {
      setGrandchildListExpanded($(this), false);
    });
  }

  function clearExpanded(){
    resetGrandchildLists();
    mobile_nav_elements.removeClass('expanded');
    mobile_nav.find('.main_nav-link-expand, .main_nav-child-link-expand').attr('aria-expanded', 'false');
    mobile_nav.find('.main_nav-link[aria-expanded]').attr('aria-expanded', 'false');
  }

  function initMobileNav() {
    $(mobile_nav_elements).each(function() {
      let nav_element = $(this);
      let expand_button = nav_element.find('.main_nav-link-expand');
      let parent_link = nav_element.find('.main_nav-link').first();
      let dropdown_back = nav_element.find('.main_nav-child-link-back');
      let child_list = nav_element.find('.main_nav-childlist');
      let child_nav_elements = child_list.find('.main_nav-childlist-item');

      mobile_nav_modal_close.on('click', function() {
        clearExpanded();
      });
      
      mobile_nav_modal_click_off.on('click', function() {
        clearExpanded();
      });

      expand_button.on('click', function(e) {
        e.preventDefault();
        clearExpanded();
        nav_element.addClass('expanded');
        expand_button.attr('aria-expanded', 'true');
        if (parent_link.length) {
          parent_link.attr('aria-expanded', 'true');
        }
      });
      
      dropdown_back.on('click', function(e) {
        e.preventDefault();
        nav_element.removeClass('expanded');
        expand_button.attr('aria-expanded', 'false');
        if (parent_link.length) {
          parent_link.attr('aria-expanded', 'false');
        }
      });

      child_nav_elements.each(function() {
        let child_nav_element = $(this);
        let child_expand_button = child_nav_element.find('.main_nav-child-link-expand');
        child_expand_button.on('click', function(e) {
          e.preventDefault();
          const willExpand = !child_nav_element.hasClass('expanded');
          setGrandchildListExpanded(child_nav_element, willExpand);
          child_expand_button.attr('aria-expanded', willExpand ? 'true' : 'false');
        });
      });
    });
  }

  initMobileNav();

})(jQuery);

// Desktop nav dropdown aria-expanded sync + Escape to close
// The dropdown itself opens via CSS (:hover / :focus-within on .main_nav-element). Escape can't
// blur a link while keeping focus in the header, so it adds .dtlr-nav-closed, which the CSS
// treats as "not focused"; the class clears once focus or the mouse leaves the item, so the
// next Tab back in (or a hover) opens it again.
(function ($) {
  var CLOSED_CLASS = 'dtlr-nav-closed';

  $('.desktop_header_menu .main_nav-element.has-dropdown').each(function () {
    var $element = $(this);
    var $link = $element.children('.main_nav-link').first();

    function setExpanded(expanded) {
      if ($link.length) {
        $link.attr('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    $element.on('mouseenter', function () {
      $element.removeClass(CLOSED_CLASS); // the mouse coming back in reopens it (CSS :hover)
      setExpanded(true);
    });

    $element.on('focusin', function () {
      if ($element.hasClass(CLOSED_CLASS)) {
        return; // closed with Escape; stays closed until focus leaves the item
      }
      setExpanded(true);
    });

    $element.on('mouseleave focusout', function (event) {
      if ($element[0].contains(event.relatedTarget)) {
        return;
      }
      $element.removeClass(CLOSED_CLASS);
      // Still open if the other input holds it (mouse left but focus stayed, or vice versa)
      if ($element[0].contains(document.activeElement) || $element.is(':hover')) {
        setExpanded(true);
        return;
      }
      setExpanded(false);
    });

    $element.on('keydown', function (event) {
      if (event.key !== 'Escape' || $element.hasClass(CLOSED_CLASS)) {
        return;
      }
      event.preventDefault();
      $element.addClass(CLOSED_CLASS);
      setExpanded(false);
      // Back to the trigger so the next Tab reaches the next top-level item
      $link.trigger('focus');
    });
  });
})(jQuery);

// Desktop nav arrow keys
// Tab walks through every link of an open dropdown before reaching the next top-level item. Arrow keys
// give a shortcut that follows the layout. Tab is unchanged.
// - On a top-level item: Right / Left move to the next / previous item (wrapping), Home / End to the
//   first / last, Down into the dropdown's first column.
// - In the dropdown, laid out as columns (each .main_nav-childlist-item: a text list or an image link
//   group): Down / Up move within the column (Up from its first link returns to the top-level item);
//   Right / Left move to the same row of the next / previous column (or its last link when shorter);
//   Right from the last column / Left from the first moves to the next / previous top-level item; Home /
//   End jump to the column's first / last link. Single-list menus (e.g. Brands) act as one column.
// Listens on window in the capture phase and stops the keys it handles: the Accessibe widget has its own
// arrow-key menu navigation that otherwise also moves focus (e.g. to the next top-level item).
(function ($) {
  var CLOSED_CLASS = 'dtlr-nav-closed';
  var KEYS = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'];
  var $nav = $('.desktop_header_menu .main_nav');
  var $topLinks = $nav.children('.main_nav-element').children('.main_nav-link');
  if (!$topLinks.length) {
    return;
  }

  function focusTop(index) {
    var count = $topLinks.length;
    $topLinks.eq((index + count) % count).trigger('focus');
  }

  // The open dropdown's links grouped by column, skipping links kept out of the Tab order (e.g. the
  // image links, whose caption link goes to the same page)
  function getColumns($element) {
    var columns = [];
    $element.find('.main_nav-dropdown .main_nav-childlist-item').each(function () {
      var links = $(this).find('a[href]').filter(function () {
        return $(this).attr('tabindex') !== '-1' && $(this).is(':visible');
      }).get();
      if (links.length) {
        columns.push(links);
      }
    });
    var singleLinks = columns.every(function (column) { return column.length === 1; });
    if (columns.length > 1 && singleLinks) {
      // A plain list of links (two-level menu): one column
      columns = [columns.map(function (column) { return column[0]; })];
    }
    return columns;
  }

  function handled(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  window.addEventListener('keydown', function (event) {
    var key = event.key;
    if (KEYS.indexOf(key) === -1 || event.altKey || event.ctrlKey || event.metaKey || !$nav[0].contains(event.target)) {
      return;
    }
    var $element = $(event.target).closest('.main_nav > .main_nav-element');
    if (!$element.length) {
      return;
    }
    var index = $topLinks.index($element.children('.main_nav-link').first());

    if (event.target === $topLinks[index]) {
      if (key === 'ArrowRight' || key === 'ArrowLeft') {
        handled(event);
        focusTop(index + (key === 'ArrowRight' ? 1 : -1));
      } else if (key === 'Home' || key === 'End') {
        handled(event);
        focusTop(key === 'Home' ? 0 : $topLinks.length - 1);
      } else if (key === 'ArrowDown') {
        $element.removeClass(CLOSED_CLASS); // an Escape-closed dropdown reopens on Down
        var firstColumns = getColumns($element);
        if (firstColumns.length) {
          handled(event);
          firstColumns[0][0].focus();
        }
      }
      return;
    }

    // Inside the dropdown
    var columns = getColumns($element);
    var col = -1;
    var row = -1;
    columns.forEach(function (column, c) {
      var r = column.indexOf(event.target);
      if (r !== -1) {
        col = c;
        row = r;
      }
    });
    if (col === -1) {
      return;
    }
    handled(event);
    var column = columns[col];

    if (key === 'ArrowDown') {
      if (row < column.length - 1) {
        column[row + 1].focus();
      }
    } else if (key === 'ArrowUp') {
      if (row > 0) {
        column[row - 1].focus();
      } else {
        $topLinks.eq(index).trigger('focus');
      }
    } else if (key === 'Home') {
      column[0].focus();
    } else if (key === 'End') {
      column[column.length - 1].focus();
    } else {
      var step = key === 'ArrowRight' ? 1 : -1;
      var target = columns[col + step];
      if (target) {
        // The link on the same line on screen: column titles are links in some columns and plain text in
        // others, so counting rows would land a line off
        var top = event.target.getBoundingClientRect().top;
        var nearest = target[0];
        target.forEach(function (link) {
          if (Math.abs(link.getBoundingClientRect().top - top) < Math.abs(nearest.getBoundingClientRect().top - top)) {
            nearest = link;
          }
        });
        nearest.focus();
      } else {
        focusTop(index + step);
      }
    }
  }, true);
})(jQuery);